import { render, staticRenderFns } from "./ConsultantRolePromotionList.vue?vue&type=template&id=bbf96fa0&scoped=true"
import script from "./ConsultantRolePromotionList.vue?vue&type=script&lang=js"
export * from "./ConsultantRolePromotionList.vue?vue&type=script&lang=js"
import style0 from "./ConsultantRolePromotionList.vue?vue&type=style&index=0&id=bbf96fa0&prod&lang=scss&scoped=true"
import style1 from "./ConsultantRolePromotionList.vue?vue&type=style&index=1&id=bbf96fa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf96fa0",
  null
  
)

export default component.exports